import React from "react";

const StepStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 3,
  width: 16,
  height: 14,
  rx: 2,
  stroke: "#101010",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.75,
  y1: 13.25,
  x2: 9.25,
  y2: 13.25,
  stroke: "#101010",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.75,
  y1: 10.25,
  x2: 17.25,
  y2: 10.25,
  stroke: "#101010",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(StepStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;